const routes: {
  name: string;
  urlPath: string;
  imagePath: string;
}[] = [
  {
    name: 'Twitter',
    urlPath: 'https://twitter.com/VisionhubLive',
    imagePath: '/images/social-media/twitter-icon-dark.png',
  },
  {
    name: 'Facebook',
    urlPath: 'https://www.facebook.com/Visionhub-387250764803905',
    imagePath: '/images/social-media/facebook-icon-dark.png',
  },
  {
    name: 'LinkedIn',
    urlPath: 'https://www.linkedin.com/company/visionhub-solutions',
    imagePath: '/images/social-media/linkedin-icon-dark.png',
  },
  {
    name: 'Instagram',
    urlPath: 'https://www.instagram.com/visionhublive',
    imagePath: '/images/social-media/instagram-icon-dark.png',
  },
  {
    name: 'Youtube',
    urlPath: 'https://www.youtube.com/channel/UCEd_RC3_RETG8_GMy4UOjMw/videos/visionhublive',
    imagePath: '/images/social-media/youtube-icon-dark.png',
  },
];

export default routes;
